/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The InlineResponse2006Goals model module.
 * @module model/InlineResponse2006Goals
 * @version v0.3
 */
export default class InlineResponse2006Goals {
  /**
   * Constructs a new <code>InlineResponse2006Goals</code>.
   * @alias module:model/InlineResponse2006Goals
   * @class
   * @param id {String}
   * @param name {String}
   * @param reminderMessage {String}
   */
  constructor(id, name, reminderMessage) {
    this.id = id;
    this.name = name;
    this.reminderMessage = reminderMessage;
  }

  /**
   * Constructs a <code>InlineResponse2006Goals</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse2006Goals} obj Optional instance to populate.
   * @return {module:model/InlineResponse2006Goals} The populated <code>InlineResponse2006Goals</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse2006Goals();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('reminder_message'))
        obj.reminderMessage = ApiClient.convertToType(data['reminder_message'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
InlineResponse2006Goals.prototype.id = undefined;

/**
 * @member {String} name
 */
InlineResponse2006Goals.prototype.name = undefined;

/**
 * @member {String} reminderMessage
 */
InlineResponse2006Goals.prototype.reminderMessage = undefined;
